import { Component } from '@angular/core';
import { isRenderingForMobileApp, contentTypeIds } from 'src/constants';
import { ContentfulService } from '~contentful/services/contentful.service';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';

export interface FooterNavSection {
  title: string;
  items: any;
}
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
  year: number = new Date().getFullYear();
  public isMobileRender = isRenderingForMobileApp;

  constructor() {}
}
